import {concat, isEqual, filter, flatMap, find, get, groupBy, map, pick, toLower, trim, size, sortBy} from 'lodash';
import {I18n} from 'react-redux-i18n';
import BaseService from '../../middleware/BaseService';
import geotabServiceProvider from '../../middleware/GeotabServiceProvider';
const { geotabService } = geotabServiceProvider.getService() || {};

export const AUTOCOMPLETE_ENDPOINT = '/search/autocomplete/vehicleOrSerialNumber';
export const GROUPS_ENDPOINT = '/groups';
const SEARCH_DVR_ENDPOINT = `/search/autocomplete/dvr`;


class HealthFiltersService extends BaseService {
  prefix = '/dvr/list';

  sortByName = list => sortBy(list, it => trim(toLower(get(it, 'name'))));

  async loadGroups() {
    const response = await this.search('', GROUPS_ENDPOINT);
    let groups = get(response, 'data', []);
    groups = filter(groups, item => item.parentGroupId !== '-1');
    groups = map(groups, item => {
      const {id, name, parentGroupId} = item;
      return {id, name, parentGroupId};
    });
    groups = groupBy(groups, 'parentGroupId');

    const cleanObj = obj => map(obj, it => pick(it, 'id', 'name'));

    const root = get(groups, '0');
    groups = flatMap(root, value => {
      const {id, name} = value;
      const children = this.sortByName(cleanObj(get(groups, id, [])));
      if (size(children) > 0) {
        const unassigned = {id, name: I18n.t('filter.group.unassigned'), selectedLabel: `${name} (${I18n.t('filter.group.unassignedSelected')})`};
        return {
          id: `root${id}`,
          name,
          root: true,
          children: concat(unassigned, children)
        };
      }
      return {id, name, children};
    });

    return this.sortByName(groups);
  }

  async predict(params) {
    if (!params || !params.text) {
      return [];
    }

    const systemId = localStorage.getItem('systemId');
    let responseList;

    if (systemId && systemId === 'geotab') {
      const responseDvrs = await this.search(params, SEARCH_DVR_ENDPOINT);
      responseList = map(get(responseDvrs, 'data', []), (e, index) => ({
        id: index,
        name: `${e.number} (${e.name})`,
        vehicle: e.number,
        serial: e.name,
        type: e.type
      }));

      const text = toLower(params.text);
      const responseGeotabVehicles = await geotabService('Get', {
        typeName: 'Device',
        search: {
          name: `%${text}%`,
          toDate: new Date()
        }
      });

      responseList = concat(responseList, map(responseGeotabVehicles, item => ({
        type: 'vehicle',
        id: item.id,
        name: item.name,
        number: item.id
      })));

      responseList = sortBy(responseList.filter(item => {
        return (item.vehicle && 
          !(responseList.some(object => (toLower(item.vehicle) === toLower(object.name) && object.type === 'vehicle')))) 
          || (item.type === 'vehicle'); 
      }), ['name']);
    } else {
      const response = await this.search(params, AUTOCOMPLETE_ENDPOINT);

      responseList = map(get(response, 'data', []), e => ({
        id: e.id || e.name,
        name: (e.name) || e.number,
        type: e.type
      }));

      const typedVehicle = {
        id: params.text,
        name: params.text,
        type: 'vehicle',
        icon: 'search'
      };

      // prepend typed text as vehicle number
      if (!responseList) {
        responseList = [typedVehicle];
      } else if (!find(responseList, it => isEqual(toLower(it.name), toLower(params.text)) && it.type === 'vehicle')) {
        responseList = concat(typedVehicle, responseList);
      }
    }
    return responseList;
  }

  async loadHealthStatus() {
    return [
      {id: 'all', label: 'all'},
      {id: 'healthy', label: 'healthy'},
      {id: 'unhealthy', label: 'notHealthy'},
      {id: 'hasnoimage', label: 'cameraIssueDetected'},
      {id: 'needsattention', label: 'needsAttention'}
    ];
  }
}

export default new HealthFiltersService();
